__turbopack_context__.v({
  "productInfoAccordionHeading": "ProductStorePC-module-scss-module__jr2caq__productInfoAccordionHeading",
  "productNotesHeading": "ProductStorePC-module-scss-module__jr2caq__productNotesHeading",
});
